import { disableCognito } from '@config';
import { IUserStore } from '@stores/user';
import LocalStorage from '@utils/localStorage';
import { useHistory } from 'react-router-dom';
import { FREETRIAL, PASSWORD_HELP_MESSAGE, WHITELISTED_DOMAINS } from './constants';

const checkIfWorkEmail = (email: string): boolean => {
  const domain = email.lastIndexOf('@') >= 0 ? email.substring(email.lastIndexOf('@') + 1) : '';
  return !(domain.trim() === '' || WHITELISTED_DOMAINS.includes(domain));
};

const validateName = (name: string): boolean => {
  const nameFormat = /^[\d ',.a-z-]+$/i;
  return nameFormat.test(name);
};

const validatePassword = (password: string) => {
  const len = password.length;
  let isValid = false;
  if (len >= 20) {
    isValid = true;
  } else if (len >= 12 && len <= 19) {
    const noBoundingSpaces = /^(?=^\S+.*\S+$)/;
    const smallCapitalDigits = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/;
    const specialChars = /(?=.*[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])/;
    const allowedChars = /[\w !"#$%&'()*+,-./:;<=>?@[\]^`{|}~]{12,19}$/;
    const regexPattern = new RegExp(
      noBoundingSpaces.source +
        smallCapitalDigits.source +
        specialChars.source +
        allowedChars.source,
    );
    isValid = regexPattern.test(password);
  }
  return {
    loading: isValid,
    error: !isValid,
    errorMessage: isValid ? '' : PASSWORD_HELP_MESSAGE,
  };
};

const getIsBlendoUser = () => LocalStorage.isFlagSet('isBlendoUser');

const hasNotSeenMfaYet = (userStore: IUserStore, providedEmail?: string) => {
  const { mfaStatus, isOpenSource } = userStore;
  const email = providedEmail || userStore.email;

  return (
    mfaStatus !== 'SMS' &&
    !isOpenSource &&
    !disableCognito &&
    !LocalStorage.isFlagSet(`mfashown${email}`)
  );
};

const letUserKnowWeSupportMfa = (
  userStore: IUserStore,
  history: ReturnType<typeof useHistory>,
  providedEmail?: string,
) => {
  const { isGoogleOrSso } = userStore;
  const email = providedEmail || userStore.email;

  if (hasNotSeenMfaYet(userStore, email) && !isGoogleOrSso) {
    LocalStorage.setFlag(`mfashown${email}`);
    history.push('/addmfa');
  } else {
    history.push('/');
  }
};

export type UTM = 'freetrial' | 'opensource';

export interface AwsUser {
  signInUserSession: {
    getIdToken: () => {
      payload: {
        name: string;
        email: string;
        identities: {
          providerName: string;
        }[];
        'custom:userId': string;
      };
      getJwtToken: () => string;
    };
    getAccessToken: () => {
      getJwtToken: () => string;
    };
    getRefreshToken: () => {
      getToken: () => string;
    };
  };
  getUsername: () => string;
}

export const getPromotionText = (utm: UTM) => {
  if (utm === FREETRIAL) {
    return 'Looking to use RudderStack Open Source?';
  }
  return 'Looking to use RudderStack Cloud?';
};

export {
  validatePassword,
  checkIfWorkEmail,
  validateName,
  getIsBlendoUser,
  letUserKnowWeSupportMfa,
};
